export default __webpack_public_path__ + "static/media/job_offer1_s.75b205aa.jpg";